import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { EquityApplicationProps } from '../..';
import { AssetValueWithPercentage } from '../../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/AssetValueWithPercentage';
import {
  EQUITY_ORDER_TYPE_LABEL,
  EQUITY_ORDER_TYPE_OPTIONS,
  EquityListItemTypes,
} from '../../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/products/Equity/ListItem';
import { EquityController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/Equity';
import { ProductCard } from '../../../../components/ProductCard';

export interface EquityInvestCardProps {
  offer: EquityApplicationProps['offer'];
  offerController: EquityController;
}

export const EquityInvestCard: React.FC<EquityInvestCardProps> = ({ offer, offerController }) => {
  const id = offer.productIdNormalized;

  const {
    amountItem,
    priceItem,
    totalPrice,
    handleChangeAmountItem,
    handleChangePriceItem,
    orderType,
    handleChangeOrderType,
  } = offerController;

  return (
    <ProductCard
      infos={[
        {
          label: 'Último preço',
          value: (
            <AssetValueWithPercentage
              value={offer.lastPriceNormalized}
              percentage={offer.priceChangeTaxValueNormalized}
              iconColor={offer.priceChangeTaxColorNormalized}
            />
          ),
        },
        { label: 'Operação ', value: 'Compra' },
        { label: 'Validade da ordem ', value: 'Hoje' },
      ]}
      productColor="product.rendavariavel"
      title={`${offer.productNameNormalized} | ${offer.symbolNormalized}`}
      BottomComponent={
        <VStack space="stack.xxxs">
          <VStack space={'stack.quarck'} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Tipo da ordem
            </UI.Text>

            <VStack borderRadius={BoxBorder.thick} bgColor="backgroundshade">
              <UI.Select
                testID={`equity-order-type-select-customer-application-${id}`}
                options={EQUITY_ORDER_TYPE_OPTIONS}
                selectedValue={orderType}
                onValueChange={(value) => {
                  handleChangeOrderType(value as EquityListItemTypes.OrderType);
                }}
                placeholder={EQUITY_ORDER_TYPE_LABEL.Limit}
              />
            </VStack>
          </VStack>
          <VStack space={'stack.quarck'} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade
            </UI.Text>

            <UI.InputStepper
              stepperValue={offer.quote.lotSize || 1}
              max={1000000}
              min={offer.quote.lotSize || 1}
              name={`equity-amount-order-input${id}`}
              testId={`equity-amount-order-input${id}`}
              keyboardType="numeric"
              fontSize={Typography['fontsize.md']}
              defaultValue={amountItem}
              onChange={handleChangeAmountItem}
              showErrorMessage={false}
              {...((totalPrice === 0 || totalPrice > 1000000) && {
                customError: 'Quantidade inválida',
              })}
            />
          </VStack>
          <VStack space={'stack.quarck'} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Preço por ativo
            </UI.Text>

            <UI.InputStepper
              stepperValue={0.01}
              max={1000000}
              min={0.01}
              fontSize={Typography['fontsize.md']}
              keyboardType="numeric"
              ignoreStepperDivision
              maskOption="money"
              name={`equity-amount-price${id}`}
              testId={`equity-amount-price${id}`}
              defaultValue={priceItem || 0.01}
              onChange={handleChangePriceItem}
              showErrorMessage={false}
              disabled={orderType === 'Market'}
              {...((totalPrice === 0 || totalPrice > 1000000) && {
                customError: 'Valor inválido',
              })}
            />
          </VStack>
          <HStack justifyContent="space-between" space={'inline.quarck'}>
            <UI.Text fontSize={Typography['fontsize.xs']}>Total estimado</UI.Text>

            <UI.Text maxW={{ base: '200px', sm: '2/3' }} variant="semibold" textAlign="right">
              {Utils.Mask.Money(totalPrice)}
            </UI.Text>
          </HStack>
        </VStack>
      }
    />
  );
};
